import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const TimetableFeature: FeatureMetadata = {
  id: "timetable",
  moduleName: "academics",
  guardianNavigation: {
    order: 5,
  },

  navigation: {
    label: "Timetable",
    path: "/timetable",
    icon: CalendarDaysIcon,
    order: 5,
  },

  route: {
    path: "/timetable/*",
    element: lazy(() => import("./pages/TimetableRoot")),
  },

  permissions: {
    view: "Academics.Timetable.view",
    create: "Academics.Timetable.create",
    edit: "Academics.Timetable.edit",
    delete: "Academics.Timetable.delete",
  },

  readiness: "live",
};

/** Slot Master (template catalog) permissions — distinct from timetable entries. */
export const SlotTemplatesPermissions = {
  view: "Academics.SlotTemplates.view",
  create: "Academics.SlotTemplates.create",
  edit: "Academics.SlotTemplates.edit",
  delete: "Academics.SlotTemplates.delete",
  assign: "Academics.SlotTemplates.assign",
} as const;
